import { useTranslation } from "~/i18n"
import Text from "~/components/UI/Text"
import Link from "~/components/UI/Link"
import { ROUTES } from "~/constant"
import IconMoon from '~/components/Icon'
const Links = () => {
  const [t] = useTranslation()
  return (
    <>
      <Text bold style={{ lineHeight: '40px' }}>
        {t('Các liên kết')}
      </Text>

      <Link target='_blank' href={ROUTES.JOBS}>
        <Text margin='8px 0' opacity={0.7}>
          {t('Cơ hội việc làm')}
        </Text>
      </Link>
      <Link target='_blank' href={ROUTES.CD_VERIFY}>
        <Text margin='8px 0' opacity={0.7}>
          {t('Kiểm tra thông tin CCTG')}
        </Text>
      </Link>
      <Link target='_blank' href={ROUTES.PRIVACY}>
        <Text margin='8px 0' opacity={0.7}>
          {t('Chính sách bảo mật')}
        </Text>
      </Link>
      <Link target='_blank' href={ROUTES.TERMS_AND_CONDITIONS}>
        <Text margin='8px 0' opacity={0.7}>
          {t('Điều khoản sử dụng')}
        </Text>
      </Link>


      <Text bold style={{ lineHeight: '40px' }}>
        {t('Truyền Thông')}
      </Text>
      <Link target='_blank' href={ROUTES.LINKED_IN}>
        <Text margin='8px 0'>
          <IconMoon name="linkedin" />
          <span style={{ opacity: 0.7 }} className="ml-2">{t`Linkedin`}</span>
        </Text>
      </Link>
      <Link target='_blank' href={ROUTES.YOUTUBE}>
        <Text margin='8px 0'>
          <IconMoon name="youtube" />
          <span style={{ opacity: 0.7 }} className="ml-2">{t`Youtube`}</span>
        </Text>
      </Link>
      <Link target='_blank' href={ROUTES.FACEBOOK}>
        <Text margin='8px 0'>
          <IconMoon name="facebook" />
          <span style={{ opacity: 0.7 }} className="ml-2">{t`Facebook`}</span>
        </Text>
      </Link>
    </>
  )
}

export default Links
